

































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { IMember } from '@/types/member'
import Membres from '@/components/Group/Membres.vue'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import orderBy from 'lodash/orderBy'

@Component({
    components: {
        Membres,
        SmoothReflow,
    },
})
export default class AperMembres extends Vue {
    @Prop() private membres: IMember[]
    @Prop() private selectedMember: IMember
    @Prop({ type: Boolean }) private disableAnimation: boolean

    pSelectedMember: IMember = null

    get orderedMembers() {
        const members = orderBy(
            this.membres,
            ['owner', 'name'],
            ['desc', 'asc']
        )
        return members
    }

    @Watch('membres', { deep: true, immediate: true })
    onMembers() {
        if (this.pSelectedMember || !this.orderedMembers) {
            return
        }
        this.pSelectedMember = this.orderedMembers[0]
    }

    @Watch('selectedMember')
    onSelectedMember() {
        if (!this.selectedMember) {
            return
        }
        this.pSelectedMember = this.selectedMember
    }

    @Watch('pSelectedMember')
    onPSelectedMember() {
        this.$emit('selectedMember', this.pSelectedMember)
    }

    smoothReflowSettings = {
        transitionEvent: {
            selector: 'div',
            propertyName: 'opacity',
        },
    }

    handleClick(membre: IMember) {
        this.pSelectedMember = membre
    }
}
